import React, { useState } from 'react';

const PredictionForm = ({ onPredict }) => {
  const [days, setDays] = useState(7);
  const [startDate, setStartDate] = useState(() => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    return date.toISOString().split('T')[0];
  });
  const [endDate, setEndDate] = useState(() => {
    const date = new Date();
    return date.toISOString().split('T')[0];
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onPredict(days, startDate, endDate);
  };

  return (
    <div className="prediction-form">
      <h2>Gold Price Analysis & Prediction</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="dateRange">Historical Date Range:</label>
          <div className="date-range-container">
            <div className="date-input">
              <label htmlFor="startDate">From:</label>
              <input
                type="date"
                id="startDate"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                required
              />
            </div>
            <div className="date-input">
              <label htmlFor="endDate">To:</label>
              <input
                type="date"
                id="endDate"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                min={startDate}
                required
              />
            </div>
          </div>
        </div>
        
        <div className="form-group">
          <label htmlFor="days">Number of Days to Predict:</label>
          <input
            type="number"
            id="days"
            value={days}
            onChange={(e) => setDays(parseInt(e.target.value))}
            min="1"
            max="30"
            required
          />
        </div>
        
        <button type="submit" className="predict-button">
          Analyze & Predict
        </button>
      </form>
    </div>
  );
};

export default PredictionForm;